export { Fredcon25 } from './Fredcon25';
